/** Locked master brand tagline — do not rewrite. (76 chars) */
export const BRAND_TAGLINE =
  'Whole-health telehealth — weight loss, TRT/HRT, urgent care, derm, and more.'

/** Tighter variant for constrained UI (header, tight bios). (65 chars) */
export const BRAND_TAGLINE_TIGHT =
  'Whole-health telehealth. Weight loss, TRT/HRT, urgent care, derm.'
